import { motion } from 'framer-motion';
import { FaBrain, FaSearch } from 'react-icons/fa';
import {
  SiPython, SiJavascript, SiFastapi, SiReact, SiDocker,
  SiAmazonwebservices, SiMongodb, SiGit, SiTensorflow, SiHuggingface, SiLangchain,
} from 'react-icons/si';
import BlurFade from '../ui/BlurFade';
import { skillCategories } from '../../data/skills';

const ICONS = {
  'Large Language Models': FaBrain,
  'RAG Systems': FaSearch,
  LangChain: SiLangchain,
  TensorFlow: SiTensorflow,
  'Hugging Face': SiHuggingface,
  Python: SiPython,
  JavaScript: SiJavascript,
  FastAPI: SiFastapi,
  React: SiReact,
  Docker: SiDocker,
  AWS: SiAmazonwebservices,
  MongoDB: SiMongodb,
  Git: SiGit,
};

const Skills = () => {
  return (
    <section id="skills" className="bg-white py-20 text-black">
      <div className="mx-auto max-w-3xl px-6">
        <BlurFade>
          <h2 className="mb-10 text-2xl font-black sm:text-3xl">
            My <span className="text-black/30">Skills</span>
          </h2>
        </BlurFade>

        <div className="flex flex-col gap-8">
          {skillCategories.map((group, gi) => (
            <div key={group.category}>
              <BlurFade delay={gi * 0.05}>
                <h3 className="mb-3 text-sm font-bold uppercase tracking-wide text-black/50">
                  {group.category}
                </h3>
              </BlurFade>
              <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-5">
                {group.skills.map((skill, si) => {
                  const Icon = ICONS[skill.name] || FaBrain;
                  return (
                    <BlurFade key={skill.name} delay={gi * 0.05 + si * 0.03}>
                      <motion.div
                        whileHover={{ scale: 1.06, y: -3 }}
                        className="flex aspect-square flex-col items-center justify-center gap-2 rounded-xl border-2 border-black p-3 text-center"
                      >
                        <Icon size={22} style={{ color: skill.color }} />
                        <span className="text-xs font-semibold leading-tight">{skill.shortName}</span>
                      </motion.div>
                    </BlurFade>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
